export function capitalizeFirstLetter(str: string | null): string | null {
  if (str == null) {
    return null;
  }
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
